/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs
*/
import React from 'react';
import HelloSignLogo from '../../assets/HS_logo_white.svg';
import EventbriteLogo from '../../assets/eventbrite_logo.png';
import EventbriteIntegration from '../../assets/eventbrite_integration.svg';
import SendIcon from '../../assets/send_icon.svg';
import CustomizeLogo from '../../assets/customize_logo.svg';
import DashboardIcon from '../../assets/dashboard_icon.svg';
import CloudLeft from '../../assets/overlay_left.svg';
import CloudRight from '../../assets/overlay_right.svg';
import Social from '../common/social-section';
import FAQ from '../common/faq-section';

function EventbriteLandingPage(p) {
  const twitterLink = 'https://twitter.com/intent/tweet?text=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20%40HelloSign%20%2B%20%40Eventbrite&url=https%3A%2F%2Fwww.hellosign.com%2Feventbrite%3Futm_source%3Dtwitter%26utm_medium%3Ds2s';
  const facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/eventbrite?utm_source=facebook%26utm_medium=s2s';
  const linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.hellosign.com/eventbrite?utm_source=linkedin%26utm_medium=s2s&title=Check%20out%20the%20HelloSign%20Extension%20for%20Eventbrite&summary=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20HelloSign%20%2B%20Eventbrite.%20https%3A//www.hellosign.com/eventbrite';

  return <div className='seo-cloud-integrations'>
    <IllustrationArea {...p} />
    <div className='seo-cloud-integrations__main' style={{ backgroundColor: 'white' }}>
      <PricingPlansCTA position='top' />
      <Benefits />
      <HowItWorks />
      <Social
        title='Share with your network!'
        twitterLink={twitterLink}
        facebookLink={facebookLink}
        linkedInLink={linkedInLink} />
      <FAQ link='https://faq.hellosign.com/hc/en-us/sections/204169818-Eventbrite' />
      <PricingPlansCTA position='bottom' />
    </div>
  </div>;
}

function IllustrationArea(p) {
  // This overlay is slightly off from the other integrations. This transform
  // compensate for that.
  const imageStyle = { transform: 'translateY(1px)' };
  return <div className='top row drobox-blue'>
    <div className='top-content-container large-5 large-push-6 columns'>
      <div className='hellosign-dropbox'>
        <img src={HelloSignLogo} alt='HelloSign Logo' className='hs-logo' />
        <span className='plus'>+</span>
        <img src={EventbriteLogo} alt='Eventbrite Logo' className='dropbox-logo' width='130' />
      </div>
      <div className='title'>
        <h1>Seamlessly Collect Event Waivers and Forms</h1>
      </div>
      <div className='subtitle'>
        <h2 style={{ fontWeight: 400, fontSize: 16, maxWidth: 600 }}>
                    The HelloSign Waivers & Forms extension for Eventbrite
                    allows you to send any event-related documents to your
                    attendees for legally-binding signature. We’ve made it easy
                    to send, track, collect, and get real-time status updates on
                    your photo releases, sponsor and exhibitor agreements,
                    permission slips, waivers, and more for your Eventbrite
                    event.
        </h2>
      </div>
      <SignupButton {...p} />
    </div>
    <div className='clouds-container large-5 large-pull-4 columns'>
      <img src={EventbriteIntegration} alt='cloud left' style={{ marginTop: 23 }} />
    </div>
    <img src={CloudLeft}
      style={imageStyle}
      alt='cloud left'
      className='cloud-left' />
    <img src={CloudRight}
      style={imageStyle}
      alt='cloud right'
      className='cloud-right' />
  </div>;
}

function SignupButton() {
  const buttonClass = 'm-button bg-cerulean hc-white c-white progress-button state-loading m-login-or-signup--sign-up-button';
  const linkURL = 'https://www.eventbrite.com/spectrum/hellosign/';

  return <div className='signup-button'>
    <a href={linkURL} className={buttonClass}>
            ENABLE HELLOSIGN WAIVERS & FORMS
    </a>
  </div>;
}

function Benefits(p) {
  const titleStyle = {
    display: 'inline-block',
    maxWidth: 250,
  };
  return <div className='seo-cloud-integrations__benefits'>
    <h2>Benefits</h2>
    <div className='row'>
      <section className='access-dropbox-from-hs large-4 columns'>
        <div className='benefits-image-container'>
          <img src={SendIcon} alt='folder icon' />
        </div>
        <h3>
          <span style={titleStyle}>
                        Send important forms automatically
          </span>
        </h3>
        <p>
                    Send your event documents to attendees that have already
                    registered and to any new attendees automatically as they
                    join. We can pre-fill fields they’ve already entered.
        </p>
      </section>
      <section className='sign-any-from-dropbox large-4 columns'>
        <div className='benefits-image-container'>
          <img src={CustomizeLogo} alt='signature icon' />
        </div>
        <h3>
          <span style={titleStyle}>
                        Customize your documents
          </span>
        </h3>
        <p>
                    Upload unique documents for different ticket types,
                    automatically pull attendee data into your documents, and
                    brand your documents with your logo, company name, and more!
        </p>
      </section>
      <section className='save-signed-copies large-4 columns end'>
        <div className='benefits-image-container'>
          <img src={DashboardIcon} alt='cloud icon' />
        </div>
        <h3>
          <span style={titleStyle}>
                        Get real-time status reports
          </span>
        </h3>
        <p>
                    Check the status of any document out for signature for any
                    attendee from your Eventbrite dashboard and download a
                    report to simplify day-of-event check-ins.
        </p>
      </section>
    </div>
  </div>;
}

function HowItWorks(p) {
  const linkURL = 'http://blog.hellosign.com/hellosign-and-eventbrite-integration/';
  const link = <a href={linkURL}>Read our blog post</a>;
  const videoProps = {
    src: 'https://www.youtube.com/embed/mQkUMjH_DxE',
    frameBorder: 0,
    style: {
      width: '100%',
      maxWidth: 800,
      height: 430,
    },
  };
  const paragraphStyle = {
    marginLeft: 20,
  };

  return <div className='seo-cloud-integrations__how-it-works'>
    <h2>How it Works</h2>
    <div className='row'>
      <div className='screenshot-explanation large-3 large-push-9 columns'>
        <p style={paragraphStyle}>
                    To get started, find the HelloSign Waivers & Forms extension
                    in Eventbrite Spectrum.
        </p>

        <p style={paragraphStyle}>
                    Once you add the extension to your event, you can upload
                    documents, assign them to ticket types, automatically send
                    your documents to registered attendees, and see which
                    documents are still out for signature.
        </p>

        <p style={paragraphStyle}>
                    All of the docs you send through the extension will show up
                    in the documents view on HelloSign.com.
        </p>

        <p style={paragraphStyle}>
                    Want to learn more about the integration? {link}.
        </p>
      </div>
      <div className='dropbox-screenshot large-9 large-pull-3 columns'>
        <iframe {...videoProps} />
      </div>
    </div>
  </div>;
}

function PricingPlansCTA(p) {
  const position = p.position;
  const className = `seo-cloud-integrations__main__free_accounts__${position}`;
  const linkURL = 'eventbrite/pricing';
  const link = <a href={linkURL} style={{ fontWeight: 500 }}>See Our Plans</a>;
  const border = '2px solid #D7D7D7';
  const style = {};
  if (position === 'top') {
    style.borderBottom = border;
    style.backgroundColor = '#f7f8f9';
  } else {
    style.borderTop = border;
  }

  return <div className={className} style={style}>
    <p style={{ fontWeight: 600, lineSpacing: 0 }}>
            The HelloSign Waivers and Forms extension for Eventbrite plans start
            at $29 a month. {link}.
    </p>
  </div>;
}

module.exports = EventbriteLandingPage;
